import Commerce from '@chec/commerce.js' ;


export const commerce = new Commerce("pk_test_2868228e8077a5a67e43b8d96fc48b70ec1b007df3ecd", true);